angular.module('CarsSaraBo').factory('SecurityUserService', ['$resource', function($resource) {
	  return $resource('../rest/user/authenticated')}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/users_service.js
// module id = 869
// module chunks = 3